import { VIEW_MODES } from '@aytm/app/stats/page/question-views/hm/components/chart/lib/constants'
import { drawDots } from '@aytm/app/stats/page/question-views/hm/components/chart/lib/render/views/dots'
import { drawHeatmap } from '@aytm/app/stats/page/question-views/hm/components/chart/lib/render/views/heatmap'
import { drawHeatmapByClusters } from '@aytm/app/stats/page/question-views/hm/components/chart/lib/render/views/heatmapByClusters'
import { drawOverlay } from '@aytm/app/stats/page/question-views/hm/components/chart/lib/render/views/overlay'
import { drawOverlayByClusters } from '@aytm/app/stats/page/question-views/hm/components/chart/lib/render/views/overlayByClusters'
import { drawSpotlight } from '@aytm/app/stats/page/question-views/hm/components/chart/lib/render/views/spotlight'

export const drawView = (container, options) => {
  const { viewMode } = options

  switch (viewMode) {
    case VIEW_MODES.HEATMAP:
    case VIEW_MODES.COLDMAP:
      return drawHeatmap(container, options)

    case VIEW_MODES.HEATMAPCLUSTERS:
      return drawHeatmapByClusters(container, options)

    case VIEW_MODES.OVERLAY:
      return drawOverlay(container, options)

    case VIEW_MODES.OVERLAYCLUSTERS:
      return drawOverlayByClusters(container, options)

    case VIEW_MODES.SPOTLIGHT:
      return drawSpotlight(container, options)

    case VIEW_MODES.DOTS:
      return drawDots(container, options)

    default:
      return null
  }
}
